// Represents a FHIR Coding value with code and display
export type CodingValue = {
  code: string
  display: string
}

// Represents an option for select/multi-select questions
export type CodingSelectOption = {
  label: string
  value: string
  code: string
  display: string
}

// RawDiagnosis field name constants
export const RAW_DIAGNOSIS_FIELDS = {
  ICD10_CODE: 'icd10_code',
  DESCRIPTION: 'description'
} as const

// Represents raw diagnosis data from API
export type RawDiagnosis = {
  icd10_code: string
  description: string
}
